<template>
    <div id="dealer-body">
        <div class="container">
            <div class="row">
                <div class="col s4">
                    <span class="sort-title">Sort By</span>
                    <select class="filter-select" v-model="filter_selected">
                        <option value="AZ" selected>A-Z</option>
                        <option value="ZA">Z-A</option>
                    </select>
                </div>
            </div>

            <div class="row" v-if="!is_loading">
                <div class="col s12" v-for="(letter, index) in letters" v-if="isAlphabetEmpty(letter, dealers) > 0">
                    <div class="row">
                        <div class="col s12">
                            <span class="alphabet">{{ letter }}</span>
                        </div>
                        <div class="col s12">
                           <div class="row">
                               <div class="col s12">
                                   <ul class="brand-list">
                                       <li v-for="dealer in dealers" v-if="isALink(letter, dealer)">
                                           <a :href="dealer.brand_link">
                                               <div class="row">
                                                   <div class="col s12" style="border: 1px solid #eee; height: 150px; display: flex;" >
                                                       <img class="responsive-img brand-img" :src="dealer.logo_url">
                                                   </div>
                                                   <div class="col s12" style="background-color: #000">
                                                       <div class="brand-title">{{ dealer.name }}</div>
                                                   </div>
                                               </div>
                                           </a>
                                       </li>
                                   </ul>
                               </div>
                           </div>
                        </div>
                    </div>
                    <hr>
                    <!--<a v-if="isALink(letter)" :href="letter">{{ letter }}</a>
                    <a v-else>{{ letter }}</a>-->
                </div>
            </div>

            <div class="row" v-if="is_loading">
                <div class="col s12 center-align">
                    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true" style="font-size: 2.5rem;"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DealerComponent",
    props: [
        'siteUrl',
        'getBrandList'
    ],
    data () {
        return {
            is_loading: false,
            dealers: [],
            filter_selected: 'AZ'
        }
    },
    computed: {
        // there have to be a way to get this array without doing it like this but I don't know it ^^
        letters() {
            let letters = []
            for(let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {letters.push(String.fromCharCode([i]))}


            if (this.filter_selected === 'AZ')
            {
                return letters;
            }
            else
            {
                return letters.slice().reverse();
            }
        },

    },
    mounted() {
      this.is_loading = true;
      this.getBrands();

    },
    methods: {
        // you may add a toUpperCase()/toLowerCase() if you're not sure of the capitalisation of you datas
        isALink(letter, dealer) {
            return dealer.name.startsWith(letter);
        },
        isAlphabetEmpty (letter, dealers) {
            let counter = 0;

            this.dealers.forEach((dealer) => {

                if (dealer.name.startsWith(letter))
                {
                    counter ++
                }
            })

            return counter;
        },
        getBrands()
        {
            let me = this;

            axios.get(this.getBrandList, {

            }).then(function (response) {
                me.dealers = response.data.brands;
                me.is_loading = false;
            }).catch(function (error){

                me.is_loading = false;
            });
        }
    }
}
</script>

<style scoped>

</style>
